export interface IUser {
  balance: number;
  cheatUser: boolean;
  userId: number;
}

export class User implements IUser {
  balance: number;
  cheatUser: boolean;
  userId: number;

  constructor(data?: Partial<IUser>) {
    this.balance = data?.balance || 0;
    this.cheatUser = data?.cheatUser || false;
    this.userId = data?.userId || -1;
  }
}
